module.exports = {"lang":"Tw","welcome":"歡迎光臨","login":{"title":"登入"}}


//////////////////
// WEBPACK FOOTER
// ./src/lang/tw.json
// module id = CUaR
// module chunks = 1